<div class="successfull-submit">
  <div class="header mb-2 pb-3">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline-white.svg"
        alt="back button"
        class="pointer-cursor hide"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'ADD_A_LOCK' | translate }}</h1>
      <img
        src="/assets/svg/ico-hamburger-close.svg"
        class="cross-button pointer-cursor hide"
        (click)="closeDialog()"
      />
    </div>

    <div class="d-flex mt-4 pt-2 pb-2">
      <h2 class="heading1 m-auto">{{ 'CONGRATS' | translate }}</h2>
    </div>
  </div>
  <div class="successfull-container">
    <div class="body pt-3">
      <div class="d-flex pb-117">
        <div>
          <img
            class="check mt-2"
            src="/assets/svg/ico-check-circle.svg"
            alt="check circle"
          />
        </div>
        <div class="message">
          <h3 class="title">{{ 'LOCK_ADDED' | translate }}</h3>
          <p class="dec">
            {{ 'LOCK_CONNECTED_TO_APP' | translate }}
          </p>
        </div>
      </div>

      <div class="bottom-detail px-4 pb-50 color-white">
        <div class="bottom-detail-box">
          <h3 class="title text-center">
            {{ 'LOCK_INSTALLATION_REQUIRED' | translate }}
          </h3>
          <p class="dec text-white-50 text-center">
            {{ 'LOCK_SETUP_COMPLETED' | translate }}
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="closeDialog()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
